module.exports = __webpack_public_path__ + "topbgc2.png?0241111e70825396e026fa12e213b9b7";